import { Component, OnInit } from '@angular/core';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { IOrganisation } from '@bciti/types';

import { CdkDragDrop, moveItemInArray, transferArrayItem, copyArrayItem } from '@angular/cdk/drag-drop';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';

@Component({
    selector: 'app-menus',
    templateUrl: './menus.component.html',
    styleUrls: ['./menus.component.scss'],
})
export class MenusComponent implements OnInit {
    organisations: IOrganisation[];
    selectedOrganisation: string;

    userMenuPrimary: Array<object>;
    userMenuSecondary: Array<object>;
    userMenuMobileLeftNavBar: Array<object>;
    userMenuMobileRightNavBar: Array<object>;

    adminMenuPrimary: Array<object>;
    adminMenuSecondary: Array<object>;
    adminMenuMobileLeftNavBar: Array<object>;
    adminMenuMobileRightNavBar: Array<object>;

    menuListUser: Array<object>;
    menuListAdmin: Array<object>;

    userMenu: object;
    adminMenu: object;

    constructor(private organisationService: OrganisationService, private configurationService: ConfigurationService) {}

    ngOnInit(): void {
        this.getOrganisations();
    }

    getOrganisations(): void {
        this.organisationService.getOrganisations().subscribe((organisations) => (this.organisations = organisations));
    }

    onOrgSelect(org) {
        const primaryMenu = 'primary';
        const secondaryMenu = 'secondary';
        const mobileLeftNavBarMenu = 'mobileLeftNavBar';
        const mobileRightNavBarMenu = 'mobileRightNavBar';
        const menuListUser = 'user';
        const menuListAdmin = 'admin';

        this.selectedOrganisation = org.tag;

        this.configurationService.getContentsByKey(org.tag, 'menu').subscribe((userMenus) => {
            this.userMenuPrimary = userMenus[primaryMenu];
            this.userMenuSecondary = userMenus[secondaryMenu];
            this.userMenuMobileLeftNavBar = userMenus[mobileLeftNavBarMenu];
            this.userMenuMobileRightNavBar = userMenus[mobileRightNavBarMenu];
        });

        this.configurationService.getContentsByKey(org.tag, 'admin-menu').subscribe((adminMenus) => {
            this.adminMenuPrimary = adminMenus[primaryMenu];
            this.adminMenuSecondary = adminMenus[secondaryMenu];
            this.adminMenuMobileLeftNavBar = adminMenus[mobileLeftNavBarMenu];
            this.adminMenuMobileRightNavBar = adminMenus[mobileRightNavBarMenu];
        });

        this.configurationService.getConfigurationByKey('ALL', 'menus').subscribe((menuList) => {
            this.menuListUser = menuList[menuListUser];
            this.menuListAdmin = menuList[menuListAdmin];
        });
    }

    drop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            if (event.container.data.indexOf(event.previousContainer.data[event.previousIndex]) === -1) {
                copyArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
            }
        }
    }

    updateMenus() {
        this.userMenu = {
            primary: this.userMenuPrimary,
            secondary: this.userMenuSecondary,
            mobileLeftNavBar: this.userMenuMobileLeftNavBar,
            mobileRightNavBar: this.userMenuMobileRightNavBar,
        };
        this.adminMenu = {
            primary: this.adminMenuPrimary,
            secondary: this.adminMenuSecondary,
            mobileLeftNavBar: this.adminMenuMobileLeftNavBar,
            mobileRightNavBar: this.adminMenuMobileRightNavBar,
        };
    }

    deleteItem(item, list) {
        list.forEach((value, index) => {
            if (value === item) {
                list.splice(index, 1);
            }
        });
    }

    saveUserMenu() {
        this.configurationService.patchContents(this.selectedOrganisation, 'menu', this.userMenu).subscribe();
    }
    saveAdminMenu() {
        this.configurationService.patchContents(this.selectedOrganisation, 'admin-menu', this.adminMenu).subscribe();
    }
}
